import { APP_ROUTES } from "const";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "lib/supabaseClient";
import { FIELD_NAMES } from "./CreateNewPasswordForm.constants";
import { ValuesType } from "./CreateNewPasswordForm.types";

export function useInitialState() {
  return useMemo(() => {
    return {
      [FIELD_NAMES.PASSWORD]: "",
      [FIELD_NAMES.NEW_PASSWORD]: "",
    };
  }, []);
}

export function useSubmitHandler() {
  const navigate = useNavigate();
  return useCallback(
    async (props: ValuesType, formikHelpers: any) => {
      try {
        const { error } = await supabase.auth.updateUser({
          password: props.password,
        });

        if (error) {
          formikHelpers.setErrors({
            non_field_errors: { detail: error.message },
          });
          return;
        }

        navigate(`${APP_ROUTES.SIGN_IN}?passwordReset=true`);
      } catch (error: any) {
        formikHelpers.setErrors({
          non_field_errors: { detail: "Something went wrong. Please try again." },
        });
      }
    },
    [navigate]
  );
}
